import { createSlice } from "@reduxjs/toolkit";

export const sqlSlice = createSlice({
    name: "SQL",
    initialState: {
        username : localStorage.getItem("username") ? localStorage.getItem("username") : "",
        password: localStorage.getItem("password") ? localStorage.getItem("password") : "",
        host: localStorage.getItem("host") ? localStorage.getItem("host") : "",
        port: localStorage.getItem("port") ? localStorage.getItem("port") : 0,
        database: localStorage.getItem("database") ? localStorage.getItem("database") : "",
        databaseDriver: localStorage.getItem("databaseDriver") ? localStorage.getItem("databaseDriver") : "",
        tableName: localStorage.getItem("tableName") ? localStorage.getItem("tableName") : "",
        tableColumns: [],
        tables: null,
        filterModel: [{id: Date.now(), column: "", operator: "", values: "", combine: false, first: true}],
        columnHeaders: [],
        limit: 5000,
        offset: 0,
    },
    reducers: {
        updateUsername: (state, action) => {
            state.username = action.payload
        },
        updatePassword: (state, action) => {
            state.password = action.payload
        },
        updateHost: (state, action) => {
            state.host = action.payload
        },
        updateDatabase: (state, action) => {
            state.database = action.payload
        },   
        updateTableName: (state, action) => {
            state.tableName = action.payload
        },
        updateFilterModel: (state, action) => {
            state.filterModel = action.payload
        },
        updateTables: (state, action) => {
            state.tables = action.payload
        },
        updateColumnHeaders: (state, action) => {
            state.columnHeaders = action.payload
        },
        updateTableColumns: (state, action) => {
            state.tableColumns = action.payload
        },
        updatePort: (state, action) => {
            state.port = action.payload
        },
        updateDatabaseDriver: (state, action) => {
            state.databaseDriver = action.payload
        },
        updateLimit: (state, action) => {
            state.limit = action.payload
        },
        updateOffset: (state, action) => {
            state.offset = action.payload
        },
        updateFilterModel: (state, action) => {
            state.filterModel = action.payload
        },
        clearFilters: (state) => {
            state.filterModel = []
            state.filterModel.push({id: Date.now(), column: "", operator: "", values: "", combine: false, first: true})
            state.limit = 5000
            state.offset = 0
        }
    }
})

export const sqlActions = sqlSlice.actions
const sqlReducers = sqlSlice.reducer
export default sqlReducers